import React, { useState, createContext } from "react"

const EditMessageContext = createContext()

const EditMessageProvider = ({ children }) => {
  const [editMessage, setEditMessage] = useState(null)

  return <EditMessageContext.Provider value={{ editMessage, setEditMessage }}>{children}</EditMessageContext.Provider>
}

export { EditMessageContext, EditMessageProvider }
